import {
  Component,
  ChangeDetectionStrategy,
  inject,
  signal,
  computed,
  HostListener,
  ElementRef,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'hp-profile-dropdown',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './profile-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    @keyframes dropdownIn {
      from { opacity: 0; transform: translateY(-6px) scaleY(0.96); }
      to   { opacity: 1; transform: translateY(0)   scaleY(1);    }
    }
    .dropdown-in {
      animation: dropdownIn 0.14s cubic-bezier(0.16, 1, 0.3, 1) forwards;
      transform-origin: top;
    }
  `],
})
export class ProfileDropdownComponent {
  private authService = inject(AuthService);
  private el = inject(ElementRef);

  readonly user = this.authService.currentUser;
  readonly warehouses = this.authService.warehouses;
  readonly selectedWarehouseId = this.authService.selectedWarehouseId;
  readonly selectedWarehouseName = this.authService.selectedWarehouseName;
  readonly open = signal(false);
  readonly warehouseMenuOpen = signal(false);

  readonly initials = computed(() => {
    const u = this.user();
    if (!u) return '?';
    return `${u.firstName.charAt(0)}${u.lastName.charAt(0)}`.toUpperCase();
  });

  toggle(): void {
    this.open.update((v) => !v);
    if (!this.open()) this.warehouseMenuOpen.set(false);
  }

  close(): void {
    this.open.set(false);
    this.warehouseMenuOpen.set(false);
  }

  toggleWarehouseMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.warehouseMenuOpen.update((v) => !v);
  }

  selectWarehouse(warehouseId: string): void {
    this.warehouseMenuOpen.set(false);
    this.changeWarehouse(warehouseId);
  }

  logout(): void {
    this.authService.logout();
  }

  changeWarehouse(warehouseId: string): void {
    this.authService.setWarehouse(warehouseId);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.el.nativeElement.contains(event.target)) {
      this.open.set(false);
      this.warehouseMenuOpen.set(false);
    }
  }
}
